import { render, staticRenderFns } from "./FeedbackBanner.vue?vue&type=template&id=65f7cc36&scoped=true&lang=html&"
import script from "./FeedbackBanner.vue?vue&type=script&lang=js&"
export * from "./FeedbackBanner.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBanner.vue?vue&type=style&index=0&id=65f7cc36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7cc36",
  null
  
)

export default component.exports